import styled from 'styled-components';

export const Circle = styled.div<{ $active: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 75px;
  height: 75px;
  border-radius: 50%;
  background-color: ${({ theme, $active }) => ($active ? theme.color.primary : theme.color.offWhite)};
  border: 1px solid ${({ theme }) => theme.color.borderColor};
  font-size: 3rem;

  svg {
    color: ${({ theme, $active }) => ($active ? theme.color.offWhite : theme.color.bodyTextColor)};
  }

  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
  }
`;
export const StyledButton = styled.button`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
    ${Circle} {
      transition: background-color 0.2s;
      background-color: ${({ theme }) => theme.color.offWhiteHover};
    }
  }
  &:disabled {
    text-decoration: none;
    cursor: default;
    ${Circle} {
      background-color: ${({ theme }) => theme.color.primary};
    }
  }
`;
